import { render, staticRenderFns } from "./BrandTypes.vue?vue&type=template&id=6dc07cbc&"
import script from "./BrandTypes.vue?vue&type=script&lang=js&"
export * from "./BrandTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports